/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { Dropdown } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../assets/images/commen-visible-icon.svg';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
} from '../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  closeTab,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';
import {
  selectedType,
  dispatchCellClick,
} from '../../Maintain/Contract/store/actions';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import { redirectURLLink } from '../../../SharedModules/CommonUtilities/commonUtilities.js';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../Maintain/Manufacturer/store/ManufacturerAction';
import { getAllManufacturerDetail } from '../../Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import { rebateColumnDef } from './tablehead';
import {
  getNDCDetails,
  setNDCErrorPopupMessage,
  setNDCDetails,
  setCurrentNDCDetailsIndex,
  setCurrentNDCDetailsSelected,
} from '../../Display/NDC/store/action';
import { getInvoiceDetailsByInvoiceNum } from '../../Display/invoice/store/actions';

const RedTextRenderComp = (props) => {
  // Create our number formatter.
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const { data } = props;
  let value = '';
  if (data?.colDef?.headerName === 'Sum Invoice Balance') {
    value = data.data.sumInvoiceBalance;
  }
  if (data?.colDef?.headerName === 'Total Interest Due') {
    value = data.data.interestDue;
  }
  if (data?.colDef?.headerName === 'Total Disputed Amount') {
    value = data.data.disputesAmt;
  }
  if (data?.colDef?.headerName === 'Total Balance') {
    value = data.data.totalBalance;
  }
  if (data?.colDef?.headerName === 'Unallocatted Due') {
    value = data.data.unAllocatedBalance;
  }
  if (data?.colDef?.headerName === 'Base State Amount Due') {
    value =
      data.data.baseStateAmountDue || data.data.baseStateAmountDue === 0
        ? data.data.baseStateAmountDue
        : data.data.baseStateAmtDue;
  }
  if (data?.colDef?.headerName === 'Sum Offset Due') {
    value = data.data.offsetDue;
  }
  if (data?.colDef?.headerName === 'Offset Due') {
    value = data.data.offsetDue;
  }
  if (data?.colDef?.headerName === 'Original Invoice Amount') {
    value =
      data.data.originalInvoiceAmount || data.data.originalInvoiceAmount === 0
        ? data.data.originalInvoiceAmount
        : data.data.origInvAMt || data.data.origInvAMt === 0
        ? data.data.origInvAMt
        : data.data.origInvoiceAmt;
  }
  if (data?.colDef?.headerName === 'Current Invoice Amount') {
    value =
      data.data.currentInvoiceAmount || data.data.currentInvoiceAmount === 0
        ? data.data.currentInvoiceAmount
        : data.data.currInvAMt || data.data.currInvAMt === 0
        ? data.data.currInvAMt
        : data.data.currInvAmt;
  }
  if (data?.colDef?.headerName === 'Current Rebate Offset Amount') {
    value =
      data.data.currRoa || data.data.currRoa === 0
        ? data.data.currRoa
        : data.data.currentRebateOffsetAmount ||
          data.data.currentRebateOffsetAmount === 0
        ? data.data.currentRebateOffsetAmount
        : data.data.currentRoa;
  }
  if (data?.colDef?.headerName === 'Base State Rebate Amount') {
    value =
      data.data.baseStateRebateAmount || data.data.baseStateRebateAmount === 0
        ? data.data.baseStateRebateAmount
        : data.data.baseStateRebateAmt;
  }
  if (data?.colDef?.headerName === 'Base State Rebate Amount 1') {
    value = data.data.baseStateRebateAmount;
  }
  if (
    data?.colDef?.headerName === 'Base State Rebate Amount 2' ||
    data?.colDef?.headerName === 'Base State Rebate Amount 3'
  ) {
    value = data.data.baseStateRebateAmt;
  }
  if (data?.colDef?.headerName === 'Base State Amount Paid') {
    value = data.data.baseStateAmountPaid;
  }
  if (data?.colDef?.headerName === 'Dispute Amount') {
    value = data.data.disputeAmt;
  }
  if (data?.colDef?.headerName === 'Current Claim Paid Amount') {
    value =
      data.data.reimbAmt || data.data.reimbAmt === 0
        ? data.data.reimbAmt
        : data.data.revisedReimburseAmt;
  }
  if (data?.colDef?.headerName === 'Interest Paid') {
    value =
      data.data.interestPaidAmt || data.data.interestPaidAmt === 0
        ? data.data.interestPaidAmt
        : data.data.interestPaid;
  }
  if (data?.colDef?.headerName === 'Unpaid Amount') {
    value = data.data.unpaidAmt;
  }
  if (data?.colDef?.headerName === 'Family Planning Amount') {
    value =
      data.data.famPlnAmt || data.data.famPlnAmt === 0
        ? data.data.famPlnAmt
        : data.data.famPlanAmt;
  }
  if (data?.colDef?.headerName === 'Adjustment Amount') {
    value = data.data.adjustmentAmount;
  }
  if (data?.colDef?.headerName === 'Unit Change Amount') {
    value = data.data.unitChangeAmt;
  }
  if (data?.colDef?.headerName === 'Principal Paid') {
    value = data.data.principalPaid
      ? data.data.principalPaid
      : data.data.amtPaid;
  }
  if (data?.colDef?.headerName === 'Offset Paid Amount') {
    value =
      data.data.offsetPaidAmount || data.data.offsetPaidAmount === 0
        ? data.data.offsetPaidAmount
        : data.data.offsetPaidAmt;
  }
  if (data?.colDef?.headerName === 'Base State Paid Amount') {
    value = data.data.baseStatePaidAmount;
  }
  if (data?.colDef?.headerName === 'Intrest Calculated') {
    value = data.data.interestCalculated;
  }
  if (data?.colDef?.headerName === 'Intrest Paid') {
    value = data.data.interestPaid;
  }
  if (data?.colDef?.headerName === 'Intrest Due') {
    value = data.data.interestDue;
  }
  if (data?.colDef?.headerName === 'Total Due') {
    value =
      data.data.totalAmountDue || data.data.totalAmountDue === 0
        ? data.data.totalAmountDue
        : data.data.totalDue;
  }
  if (data?.colDef?.headerName === 'Original Units') {
    value = data.data.originalUnits;
  }
  if (data?.colDef?.headerName === 'Current Units') {
    value = data.data.currentUnits;
  }
  if (data?.colDef?.headerName === 'Units Paid') {
    value = data.data.unitsPaid;
  }
  if (data?.colDef?.headerName === 'Units Unpaid') {
    value = data.data.unitsUnpaid;
  }
  if (data?.colDef?.headerName === 'Units Disputed') {
    value = data.data.unitsDisputed;
  }
  if (data?.colDef?.headerName === 'Disputed Amount') {
    value =
      data.data.disputedAmount || data.data.disputedAmount === 0
        ? data.data.disputedAmount
        : data.data.disputedAmt || data.data.disputedAmt === 0
        ? data.data.disputedAmt
        : data.data.disputeAmt;
  }
  if (data?.colDef?.headerName === 'Original UROA') {
    value = data.data.originalUROA;
  }
  if (data?.colDef?.headerName === 'Current UROA') {
    value = data.data.currentUROA;
  }
  if (data?.colDef?.headerName === 'Original Invoice Scripts') {
    value = data.data.originalInvoiceScripts;
  }
  if (data?.colDef?.headerName === 'Original Reimburse Amount on Claims') {
    value = data.data.originalReimburseAmountOnClaims;
  }
  if (data?.colDef?.headerName === 'Original Other Payments From Claims') {
    value = data.data.originalOtherpaymentsfromClaims;
  }
  if (data?.colDef?.headerName === 'Current Reimburse Amount on Claims') {
    value = data.data.currentReimburseAmountOnClaims;
  }
  if (data?.colDef?.headerName === 'Current Other Payments From Claims') {
    value = data.data.currentOtherPaymentsfromClaims;
  }
  if (data?.colDef?.headerName === 'Current Scripts') {
    value = data.data.currentScripts;
  }
  if (data?.colDef?.headerName === 'Interest Calculated') {
    value = data.data?.interestCalculated;
  }
  if (data?.colDef?.headerName === 'Base State Rebate Amount 1') {
    value = data.data?.baseStateRebateAmount;
  }
  if (data?.colDef?.headerName === 'Federal Amount') {
    value =
      data.data.federalAmount || data.data.federalAmount === 0
        ? data.data.federalAmount
        : data.data.fedAmt;
  }
  if (data?.colDef?.headerName === 'State Amount') {
    value =
      data.data.stateAmount || data.data.stateAmount === 0
        ? data.data.stateAmount
        : data.data.stateAmt;
  }
  if (data?.colDef?.headerName === 'Most Recent URA') {
    value = data.data.mostRecentURA;
  }
  if (data?.colDef?.headerName === 'Current URA') {
    value = data.data.currentURA;
  }
  if (data?.colDef?.headerName === 'Original URA') {
    value = data.data.originalURA;
  }
  if (data?.colDef?.headerName === 'Current ROA') {
    value = data.data.currentRebateOffsetAmount;
  }
  if (data?.colDef?.headerName === 'Interest Due') {
    value = data.data.interestDue;
  }
  if (data?.colDef?.headerName === 'Principal Due') {
    value =
      data.data.currBal || data.data.currBal === 0
        ? data.data.currBal
        : data.data.currBalance || data.data.currBalance === 0
        ? data.data.currBalance
        : data.data.principalDue || data.data.principalDue === 0
        ? data.data.principalDue
        : data.data.currBalDue;
  }
  if (data?.colDef?.headerName === 'Reimbursement Amount') {
    value = data.data.reimburseAmt;
  }
  if (data?.colDef?.headerName === 'Overridden Change Amount') {
    value = data.data.overridenChangeAmount;
  }
  if (data?.colDef?.headerName === 'Overridden ROA Change Amount') {
    value = data.data.overridenRoaChangeAmt;
  }
  if (data?.colDef?.headerName === 'Total Change Amount') {
    value = data.data.totChangeAmt;
  }

  if (
    value === null ||
    isNaN(parseFloat(value)) ||
    value === '' ||
    value === undefined
  ) {
    return '';
  }
  if (value && parseFloat(value) < 0)
    return (
      <span style={{ color: '#eb0000' }}>
        {'(' + formatter.format(-value).replace(/^(\D+)/, '$1 ') + ')'}
      </span>
    );

  return <span>{formatter.format(value).replace(/^(\D+)/, '$1 ')}</span>;
  // return value;
};
// const RedTextRenderCompKeyChange = (props) => {
//   // Create our number formatter.
//   const formatter = new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency: 'USD',
//   });
//   const { data } = props;
//   let value = '';
//   if (data?.colDef?.headerName === 'Offset Due') {
//     value = data.data.offsetDue;
//   }
//   if (data?.colDef?.headerName === 'Total Due') {
//     value = data.data.totalDue;
//   }
//   if (data?.colDef?.headerName === 'Principal Paid') {
//     value = data.data.amtPaid;
//   }
//   if (data?.colDef?.headerName === 'Offset Paid Amount') {
//     value = data.data.offsetPaidAmt;
//   }
//   if (value === null || parseFloat(value) === NaN) return value;
//   if (value && parseFloat(value) < 0)
//     return (
//       <span style={{ color: 'red' }}>
//         {'(' + formatter.format(-value).replace(/^(\D+)/, '$1 ') + ')'}
//       </span>
//     );
//   return <span>{formatter.format(value).replace(/^(\D+)/, '$1 ')}</span>;
//   // return value;
// };
export default RedTextRenderComp;
